import { productAIService } from '../../helpers/services/productAI.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper, sessionHelper } from '@/utils'
import { SESSION } from "@/constants";
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_AI_MODULE = 'productAi'; 

// define action 
export const GET_ALL_PRODUCT_AIS = 'getAllProductAIs';
export const GET_PRODUCT_AI = 'getProductAI';
export const UPDATE_PRODUCT_AI = 'updateProductAI';
export const CREATE_PRODUCT_AI = 'createProductAI';
export const UPDATE_PRODUCT_AI_STATUS = 'updateProductAIStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCT_AIS_REQUEST = "getAllProductAIs";
const GET_PRODUCT_AI_REQUEST = "getProductAI";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCT_AIS]({ commit }, { filter }) {
        await productAIService
            .getAllProductAIs(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCT_AIS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT_AI]({ commit }, { id }) {
        productAIService
            .getProductAI(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_AI_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_AI]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        productAIService
            .updateProductAI(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess)
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.productAI')]);

                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_AI]({ commit }, { data, isCloseWhenSuccess }) {
        commit(REQUEST)
        productAIService
            .createProductAI(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    commit(SUCCESS, isCloseWhenSuccess); 
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.productAI')]);

                    if(isCloseWhenSuccess == false) {
                        sharedHelper.alertSuccessMessage(message)
                    }
                    else {
                        sharedHelper.alertSuccessMessageAndClose(message)
                    }
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_AI_STATUS]({ dispatch }, { filter, data }) {
        productAIService
            .updateProductAIStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCT_AIS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    }

};

export const mutations = {

    [SUCCESS](state, isCloseWhenSuccess) {
        state.status = {};
        if(isCloseWhenSuccess == false) {
            router.push({ name: "Product-ai-listing" });
        }
        else {
            sessionHelper.clearSearch(SESSION.PRODUCT_SPECIAL_SEARCH)
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCT_AIS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                concentration: o.concentration,
                product: o.rnd_product,
                activeIngredient: o.rnd_active_ingredient,
                isActive: o.is_active,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_AI_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            concentration: o.concentration,
            product: o.rnd_product,
            activeIngredient: o.rnd_active_ingredient,
            isActive: o.is_active,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            productID: o.rnd_product != null ? {
                value: o.rnd_product.uuid,
                text: o.rnd_product.name
            } : '',
            aiID: o.rnd_active_ingredient != null ? {
                value: o.rnd_active_ingredient.uuid,
                text: o.rnd_active_ingredient.name
            } : '',
        }
    }
}


